module.exports = __webpack_public_path__ + "static/img/s2.e87246c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/s2.png
// module id = K9TM
// module chunks = 0